const TYPES = {
  Hostname: Symbol.for('Hostname'),
  Locale: Symbol.for('Locale'),
  AppConfig: Symbol.for('AppConfig'),
  DomainConfig: Symbol.for('DomainConfig'),
  Nonce: Symbol.for('Nonce'),
};

export { TYPES };
